import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-hot-toast";
import { MdDelete } from "react-icons/md"; // Ícono de eliminación
import API_BASE_URL from "../../../../config/config.js";

import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";

const ModalGivePermisosMenu = ({ open, setOpen, user }) => {
    const [itemsMenu, setItemsMenu] = useState([]); // Todos los items disponibles
    const [userMenus, setUserMenus] = useState([]); // Menús actuales del usuario
    const [selectedItem, setSelectedItem] = useState(null); // Item seleccionado

    useEffect(() => {
        if (user?.rol === 1) return; // No cargar datos si es rol 1

        const fetchData = async () => {
            try {
                const responseItems = await axios.get(`${API_BASE_URL}/itemsmenubar`);
                setItemsMenu(
                    responseItems.data.map((item) => ({
                        value: item.iditem,
                        label: item.name,
                    }))
                );

                const responseUserMenus = await axios.post(`${API_BASE_URL}/menu_items`, {
                    iduser: user.iduser,
                });
                setUserMenus(responseUserMenus.data);
            } catch (error) {
                console.error("Error al traer datos:", error);
            }
        };

        if (user && user.iduser) {
            fetchData();
        }
    }, [user]);

    const handleAddAccess = async () => {
        if (!selectedItem) {
            toast.error("Por favor, selecciona un ítem del menú antes de agregar.");
            return;
        }

        const alreadyExists = userMenus.some(
            (menu) => menu.items_menu_bar.iditem === selectedItem.value
        );

        if (alreadyExists) {
            toast.error("Este acceso ya está asignado.");
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/menu_create`, {
                iduser: user.iduser,
                iditem: selectedItem.value,
            });

            toast.success("Acceso agregado exitosamente.");

            // Usa el dato completo del backend
            const newMenu = response.data.data;

            setUserMenus((prev) => [...prev, newMenu]);

            setSelectedItem(null);
        } catch (error) {
            console.error("Error al agregar acceso:", error);
            toast.error("Ocurrió un error al agregar el acceso.");
        }
    };

    const handleDeleteAccess = async (idmenu, iditem) => {
        if (iditem === 2 || iditem === 9) {
            toast.error("No se puede eliminar este ítem.");
            return;
        }

        try {
            await axios.delete(`${API_BASE_URL}/menu_delete`, {
                data: { idmenu },
            });

            toast.success("Acceso eliminado exitosamente.");

            // Actualizar la lista de accesos del usuario
            setUserMenus((prev) => prev.filter((menu) => menu.idmenu !== idmenu));
        } catch (error) {
            console.error("Error al eliminar acceso:", error);
            toast.error("Ocurrió un error al eliminar el acceso.");
        }
    };

    return (
        <Modal
            aria-labelledby="modal-title"
            aria-describedby="modal-desc"
            open={open}
            onClose={() => setOpen(false)}
            sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
            <Sheet
                variant="outlined"
                sx={{
                    minWidth: 300,
                    maxWidth: 500,
                    width: "100%",
                    borderRadius: "md",
                    p: 3,
                    boxShadow: "lg",
                }}
            >
                <ModalClose variant="plain" sx={{ m: 1 }} />
                <Typography
                    component="h2"
                    id="modal-title"
                    level="h4"
                    textColor="inherit"
                    sx={{ fontWeight: "lg", mb: 1 }}
                >
                    Permisos de Menú
                </Typography>

                {user?.rol === 1 ? (
                    <Typography
                        textColor="text.secondary"
                        sx={{ textAlign: "center", mt: 2 }}
                    >
                        Acceso a todos los Items del Menú
                    </Typography>
                ) : (
                    <div className="space-y-4">
                        <div className="flex items-center space-x-3">
                            <Select
                                options={itemsMenu}
                                value={selectedItem}
                                onChange={(option) => setSelectedItem(option)}
                                placeholder="Selecciona un ítem del menú"
                                className="w-full"
                            />
                            <button
                                className="bg-blue-500 text-white px-4 py-2 rounded shadow hover:bg-blue-600 focus:outline-none"
                                onClick={handleAddAccess}
                            >
                                Agregar
                            </button>
                        </div>

                        <div className="mt-4">
                            <h3 className="text-lg font-semibold text-gray-700 mb-2">
                                Accesos actuales
                            </h3>
                            {userMenus.length > 0 ? (
                                <ul className="space-y-2">
                                    {userMenus
                                        .slice()
                                        .sort((a, b) => a.items_menu_bar.iditem - b.items_menu_bar.iditem)
                                        .map((menu) => (
                                            <li
                                                key={menu.idmenu}
                                                className="flex justify-between items-center bg-gray-100 p-3 rounded-lg shadow"
                                            >
                                                <span className="text-gray-700 font-medium">
                                                    {menu.items_menu_bar.name}
                                                </span>
                                                <MdDelete
                                                    className={`${menu.items_menu_bar.iditem === 2 ||
                                                        menu.items_menu_bar.iditem === 9
                                                        ? "text-gray-400 cursor-not-allowed"
                                                        : "text-red-500 cursor-pointer"
                                                        }`}
                                                    onClick={() =>
                                                        handleDeleteAccess(
                                                            menu.idmenu,
                                                            menu.items_menu_bar.iditem
                                                        )
                                                    }
                                                />
                                            </li>
                                        ))}
                                </ul>
                            ) : (
                                <p className="text-gray-500 text-center">
                                    No hay accesos asignados actualmente.
                                </p>
                            )}
                        </div>
                    </div>
                )}
            </Sheet>
        </Modal>
    );
};

export default ModalGivePermisosMenu;
